import { Col, Row, Typography } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

import { MenuItem } from 'src/features/layout/hooks/useSideMenuItems';

import { LastAccessedItem } from './LastAccessedItem';

interface LastAccessedPagesProps {
  items: MenuItem[];
}

const { Text } = Typography;

export const LastAccessedPages: FC<LastAccessedPagesProps> = ({ items }) => {
  return (
    <Wrapper>
      <Text style={{ fontSize: '14px', fontWeight: 600, color: '#FFFFFFD9' }}>
        Recentes
      </Text>
      <Row gutter={24} style={{ width: '100%' }}>
        {items.map(item => (
          <Col span={6} key={item.key}>
            <LastAccessedItem item={item} />
          </Col>
        ))}
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  gap: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
